import React, { useEffect, useState } from 'react';
import { database, auth, functions } from '../modules/fireBase';
import {
  Layout,
  Menu,
  Table,
  Typography,
  Tooltip,
  Button,
  BackTop,
  message,
  Space,
} from 'antd';
import '../assets/styles/Logs.css';
import CustomLayout from './CustomLayout';
import { FaEye, FaExclamationTriangle } from 'react-icons/fa';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/fr';
import utc from 'dayjs/plugin/utc'; // dependent on utc plugin
import timezone from 'dayjs/plugin/timezone';
import FilterLogs from '../component/FilterLogs';
import moment from 'moment-timezone';
const { Title } = Typography;

const columns = [
  {
    key: 'nom',
    title: 'Nom',
    dataIndex: 'nom',
    //defaultSortOrder: 'ascend',
    sorter: (a, b) => a.nom && a.nom.localeCompare(b.nom),
    render: (value, record, rowIndex) => (
      <div>
        {record.nom
          ? value
          : formatPhoneNumber(record.phonenumber.replace('+1', ''))}
      </div>
    ),
  },
  {
    key: 'prenom',
    title: 'Prénom',
    dataIndex: 'prenom',
    //defaultSortOrder: 'ascend',
    sorter: (a, b) => a.prenom && a.prenom.localeCompare(b.prenom),
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    render: (date) => (
      <div>{dayjs(date).tz().format('YYYY-MM-DD [à] HH:mm:ss')}</div>
    ),
    sorter: (a, b) => dayjs(a.date).tz().diff(dayjs(b.date).tz()),
    defaultSortOrder: 'descend',
  },
  // {
  //   title: 'Status',
  //   dataIndex: 'status',
  //   key: 'status',
  // },
  {
    //title: 'Message',
    width: 100,
    dataIndex: 'message',
    key: 'message',
    render: (message, record) => {
      console.log(record);
      return (
        <Space style={{ textAlign: 'center' }}>
          <Tooltip
            placement="left"
            title={message}
            overlayStyle={{
              whiteSpace: 'pre-line',
              maxWidth: 600,
            }}>
            <Button
              icon={<FaEye />}
              //disabled={disabled}
              onClick={() => {
                // setModalRecord(record);
                // setModalMessageVisible(true);
                //console.log(record);
              }}
            />
          </Tooltip>
          {record.errorMessage && (
            <Tooltip
              placement="left"
              title={record.errorMessage}
              overlayStyle={{
                whiteSpace: 'pre-line',
                maxWidth: 600,
              }}>
              <Button
                icon={<FaExclamationTriangle />}
                //disabled={disabled}
                onClick={() => {
                  // setModalRecord(record);
                  // setModalMessageVisible(true);
                  //console.log(record);
                }}
              />
            </Tooltip>
          )}
        </Space>
      );
    },
  },
];

export default function Logs() {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(customParseFormat);
  dayjs.tz.setDefault('America/New_York');
  const [data, setData] = useState([]);
  const [contactsChantier, setContactsChantier] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resultsNumber, setResultsNumber] = useState('');
  useEffect(() => {
    database.ref('chantierContacts').once('value', (snapshot) => {
      if (snapshot.val()) {
        var firebaseData = Object.values(snapshot.val()).map((item, index) => {
          return {
            key: Object.keys(snapshot.val())[index],
            ...item,
          };
        });
        firebaseData.sort((a, b) => {
          return a.nom.localeCompare(b.nom);
        });
        setContactsChantier(firebaseData);
      }
    });
  }, []);
  const getLogs = (values) => {
    setLoading(true);
    setData([]);
    setResultsNumber('');
    var fb_getLogs = functions.httpsCallable('getlogs');
    let datedebut = values.date && values.date[0].format('YYYY-MM-DD');
    let datefin = values.date && values.date[1].format('YYYY-MM-DD');
    let to = values.destinataires?.map((destinataire) => {
      let fullcontact = contactsChantier.find(
        (contact) => destinataire === contact.nom + ' ' + contact.prenom
      );
      return '+1' + fullcontact.phonenumber.replace(/[( )-]/g, '');
    });
    fb_getLogs({
      contactsChantier,
      datedebut,
      datefin,
      to: to,
    }).then((result) => {
      setData(result.data);
      console.log(result.data);
      if (result.data.length === 0) {
        setResultsNumber("Aucun résultat n'a été trouvé");
      } else if (result.data.length === 1) {
        setResultsNumber('1 résultat a été trouvé');
      } else if (result.data.length > 1) {
        setResultsNumber(`${result.data.length} résultats ont été trouvés`);
      }
      setLoading(false);
    });
  };
  const reset = () => {
    setData([]);
    setLoading(false);
    setResultsNumber('');
  };
  return (
    <CustomLayout
      selectedKey="7"
      contentStyle={{
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Title>Logs</Title>
      <FilterLogs
        contactsChantier={contactsChantier}
        getLogs={getLogs}
        loading={loading}
        resultsNumber={resultsNumber}
        reset={reset}
      />
      <Table
        columns={columns}
        dataSource={data}
        sticky
        pagination={false}
        loading={loading}
      />
      <BackTop />
    </CustomLayout>
  );
}

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}
